import { render, staticRenderFns } from "./CreatePaymentsForm.vue?vue&type=template&id=1cfc5b01&scoped=true&"
import script from "./CreatePaymentsForm.vue?vue&type=script&lang=ts&"
export * from "./CreatePaymentsForm.vue?vue&type=script&lang=ts&"
import style0 from "./CreatePaymentsForm.vue?vue&type=style&index=0&id=1cfc5b01&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfc5b01",
  null
  
)

export default component.exports